/* ===========================================================================
   MAVELY GIVEAWAY  v1   (MV121)  —  the site half of the "Giveaway Banner" tab
   ===========================================================================
   1. THE BANNER. The yellow ticket at the top of the page ("Shorten 150+
      links, get Mavelylink Poster free for 14 days"), placed above the three
      columns, in the site's language: English, العربية (right to left),
      Español or Français. It follows the language switcher live.

   2. THE WINNER POPUP. Shown to a visitor whose user ID (the Link Ledger's
      "ID: 160_178_169_95") has a Free Serial set in the dashboard, on every
      visit until they press Copy key. The key is asked from the server for
      this visitor only — it is never in the page.

   Loaded only when index.php adds it (the Giveaway is switched on and there is
   a banner to show or a popup for this visitor). index.php puts it BEFORE the
   app's module script, so the banner is inserted in the same frame the app
   first paints — nothing on the page moves.

   The words come from window.__mvGwCfg (index.php, from the dashboard; an
   empty field there already falls back to English). The animation is the one
   of the two reference designs; see mavely-giveaway.v1.css.

   Without __mvGwCfg (the dashboard loads this file for its previews) it does
   nothing but expose window.MavelyGiveaway.

   Console: __mvGiveaway()
   =========================================================================== */
(function () {
  'use strict';

  if (window.MavelyGiveaway && window.MavelyGiveaway.version) return;

  var CFG = (window.__mvGwCfg && typeof window.__mvGwCfg === 'object') ? window.__mvGwCfg : null;
  var SVGNS = 'http://www.w3.org/2000/svg';
  var XLINK = 'http://www.w3.org/1999/xlink';
  var DONE_KEY = 'mv_gw_done';
  var uid = 0;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var stats = { banner: 0, relang: 0, popup: 0, copied: 0, reported: 0 };

  /* ============================================================ language === */

  function store(k, v) {
    try {
      if (v === undefined) return window.localStorage.getItem(k);
      window.localStorage.setItem(k, v);
    } catch (e) { }
    return null;
  }

  /* The language React starts in: exactly its own rule (sh_lang, else the
     browser's language). Read before React's first effect has had the chance
     to set <html lang>, so the banner is right in the very first frame. */
  function reactLang() {
    var s = store('sh_lang');
    if (s === 'ar' || s === 'en') return s;
    return /^ar\b/i.test(navigator.language || '') ? 'ar' : 'en';
  }

  /* English and العربية are the app's own; Español and Français are the
     mavely-i18n layer on top of English (it sets <html lang> to es / fr and
     remembers the choice in mv_lang, even before it has loaded). */
  function siteLang() {
    var h = String(document.documentElement.getAttribute('lang') || '').toLowerCase().slice(0, 2);
    if (h === 'es' || h === 'fr') return h;
    var m = store('mv_lang');
    if (m === 'es' || m === 'fr') return m;
    if (h === 'ar') return 'ar';
    return reactLang();
  }

  var EN = {
    dir: 'ltr', main: 'Shorten 150+ links, get Mavelylink Poster free for 14 days',
    sub: 'Our automated publisher tool, as a thank-you to all new and existing users.',
    until: 'Valid until', date: 'Dec 31, 2026', stampTop: 'GIVEAWAY', stampMid: 'FREE', stampBot: '14 DAYS',
    title: 'Congratulations, you\u2019ve earned it!',
    body: 'You\u2019ve shortened more than 150 links with us. As a thank-you, here\u2019s a free 14-day license for Mavelylink Poster, our automated publisher tool.',
    label: 'Your license key', help: 'Paste it into Mavelylink Poster to activate your license.',
    fine: 'Offer valid until Dec 31, 2026.', copy: 'Copy key', copied: 'Copied!', download: 'Download', close: 'Close'
  };

  /** The words for one language; any missing field is the English one. */
  function words(texts, l) {
    var t = (texts && texts[l]) || (texts && texts.en) || EN;
    var en = (texts && texts.en) || EN;
    var out = {};
    for (var k in EN) {
      if (!Object.prototype.hasOwnProperty.call(EN, k)) continue;
      var v = t[k];
      if (v === undefined || v === null || String(v).trim() === '') v = en[k];
      if (v === undefined || v === null || String(v).trim() === '') v = EN[k];
      out[k] = String(v);
    }
    out.dir = (l === 'ar') ? 'rtl' : 'ltr';
    return out;
  }

  /* ============================================================= helpers === */

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined && text !== null) n.textContent = text;
    return n;
  }
  function sv(tag, attrs) {
    var n = document.createElementNS(SVGNS, tag);
    if (attrs) for (var k in attrs) if (Object.prototype.hasOwnProperty.call(attrs, k)) n.setAttribute(k, attrs[k]);
    return n;
  }
  /** "14 days", "150 links": a number never ends a line on its own. */
  function nb(s) { return String(s || '').replace(/(\d) (?=\S)/g, '$1\u00a0'); }
  /** Writes text, keeping "Mavelylink Poster" on one line. */
  function fill(node, text) {
    node.textContent = '';
    var parts = nb(text).split('Mavelylink Poster');
    for (var i = 0; i < parts.length; i++) {
      if (i) node.appendChild(el('span', 'mvgw-nowrap', 'Mavelylink Poster'));
      if (parts[i]) node.appendChild(document.createTextNode(parts[i]));
    }
  }

  /* ========================================================== the stamp === */

  function textPath(href, key, cls) {
    var t = sv('text', { 'class': cls });
    var p = sv('textPath', { href: href, startOffset: '50%', 'text-anchor': 'middle', 'data-k': key });
    try { p.setAttributeNS(XLINK, 'xlink:href', href); } catch (e) { }
    t.appendChild(p);
    return t;
  }

  var STAR = '0,-5 1.23,-1.7 4.76,-1.55 2,.65 2.94,4.05 0,2.1 -2.94,4.05 -2,.65 -4.76,-1.55 -1.23,-1.7';

  function stamp(cls) {
    var id = 'mvgw' + (++uid) + '-';
    var s = sv('svg', { 'class': cls, viewBox: '0 0 120 120', focusable: 'false', 'aria-hidden': 'true' });
    var defs = sv('defs');
    defs.appendChild(sv('path', { id: id + 'top', d: 'M 18 60 A 42 42 0 0 1 102 60' }));
    defs.appendChild(sv('path', { id: id + 'bot', d: 'M 8 60 A 52 52 0 0 0 112 60' }));
    var f = sv('filter', { id: id + 'ink', x: '-10%', y: '-10%', width: '120%', height: '120%' });
    f.appendChild(sv('feTurbulence', { type: 'fractalNoise', baseFrequency: '1.2', numOctaves: '2', seed: '4', result: 'noise' }));
    f.appendChild(sv('feColorMatrix', { 'in': 'noise', type: 'matrix', values: '0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 -6 4', result: 'grain' }));
    f.appendChild(sv('feComposite', { 'in': 'SourceGraphic', in2: 'grain', operator: 'in' }));
    defs.appendChild(f);
    s.appendChild(defs);
    var g = sv('g', { filter: 'url(#' + id + 'ink)' });
    g.appendChild(sv('circle', { cx: '60', cy: '60', r: '56', fill: 'none', stroke: 'currentColor', 'stroke-width': '4' }));
    g.appendChild(sv('circle', { cx: '60', cy: '60', r: '35', fill: 'none', stroke: 'currentColor', 'stroke-width': '1.6' }));
    g.appendChild(textPath('#' + id + 'top', 'stampTop', 'mvgw-ring'));
    g.appendChild(textPath('#' + id + 'bot', 'stampBot', 'mvgw-ring'));
    g.appendChild(sv('polygon', { fill: 'currentColor', transform: 'translate(13 60)', points: STAR }));
    g.appendChild(sv('polygon', { fill: 'currentColor', transform: 'translate(107 60)', points: STAR }));
    var core = sv('text', { 'class': 'mvgw-core', x: '60', y: '71.5', 'text-anchor': 'middle', 'data-k': 'stampMid' });
    g.appendChild(core);
    s.appendChild(g);
    return s;
  }

  function paintStamp(svg, t) {
    var n = svg.querySelectorAll('[data-k]');
    for (var i = 0; i < n.length; i++) n[i].textContent = t[n[i].getAttribute('data-k')] || '';
  }

  /* A word's length is measured on a canvas, with the font, size and
     letter-spacing the stylesheet gives the stamp: no page layout is needed
     for it (Chrome also measured the text on the lower ring wrong, up to
     twice its length, while the stamp was being animated in). */
  var measureCtx = null;
  function wordLength(el, text, cs) {
    if (measureCtx === null) {
      try { measureCtx = document.createElement('canvas').getContext('2d') || false; } catch (e) { measureCtx = false; }
    }
    var ls = parseFloat(cs.letterSpacing) || 0;
    var n = (text.match(/[\s\S]/g) || []).length;
    if (!measureCtx) return el.getComputedTextLength ? el.getComputedTextLength() : 0;
    measureCtx.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
    return measureCtx.measureText(text).width + n * ls;
  }

  /** Shrinks a stamp word that would not fit its ring (a longer language, a
      long custom word): letters and letter-spacing alike, so it ends exactly
      at the ring's length. The built-in words all fit. */
  function fitStamp(root) {
    var list = root ? root.querySelectorAll('[data-k]') : [];
    var jobs = [], i, j;
    for (i = 0; i < list.length; i++) {
      var w = list[i];
      var target = (w.tagName.toLowerCase() === 'textpath') ? w.parentNode : w;
      var key = w.getAttribute('data-k');
      target.style.fontSize = '';
      target.style.letterSpacing = '';
      jobs.push({ t: target, text: w.textContent || '', max: key === 'stampMid' ? 58 : (key === 'stampTop' ? 112 : 146) });
    }
    for (i = 0; i < jobs.length; i++) {
      j = jobs[i];
      try {
        var cs = getComputedStyle(j.t);
        j.len = wordLength(j.t, j.text, cs);
        j.fs = parseFloat(cs.fontSize) || 0;
        j.ls = parseFloat(cs.letterSpacing) || 0;
      } catch (e) { j.len = 0; }
    }
    for (i = 0; i < jobs.length; i++) {
      j = jobs[i];
      if (!(j.len > j.max) || !j.fs) continue;
      var k = j.max / j.len;
      j.t.style.fontSize = (j.fs * k).toFixed(2) + 'px';
      if (j.ls) j.t.style.letterSpacing = (j.ls * k).toFixed(2) + 'px';
    }
  }

  /* ========================================================= the banner === */

  /* The reference's 14 pieces: where each lands from the middle of the stamp
     (x, y in px), its turn, its colour (b)lue (m)int (s)tamp-red (i)nk (w)hite.
     Every third one is a round dot, the others are 6 x 10 strips. */
  var CONFETTI = [
    [-62, -34, 220, 'b'], [-80, 10, -170, 'm'], [-50, 40, 200, 's'],
    [-18, -50, -230, 'i'], [24, -52, 150, 'm'], [-98, -20, -130, 'b'],
    [64, -40, 210, 's'], [84, 12, -190, 'm'], [10, 54, 170, 'b'],
    [58, 44, 260, 's'], [-102, 32, -250, 'i'], [-30, 52, 190, 'b'],
    [42, -24, 310, 'w'], [-46, -14, -300, 'w']
  ];

  /** All 14 pieces where they land, drawn once: one group for the wide
      layouts and one for phones (the reference's shorter .55 / .7 throw),
      mirrored in a right-to-left language. One element, one animation. */
  function paintConfetti(svg, dir) {
    if (svg.getAttribute('data-dir') === dir) return;
    svg.setAttribute('data-dir', dir);
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    var m = dir === 'rtl' ? -1 : 1;
    var sets = [['mvgw-cf-w', 1, 1], ['mvgw-cf-p', 0.55, 0.7]];
    for (var s = 0; s < sets.length; s++) {
      var g = sv('g', { 'class': sets[s][0] });
      for (var i = 0; i < CONFETTI.length; i++) {
        var c = CONFETTI[i];
        var at = 'translate(' + (c[0] * sets[s][1] * m).toFixed(1) + ' ' + (c[1] * sets[s][2]).toFixed(1) + ')';
        var piece = (i % 3 === 2)
          ? sv('circle', { r: '3.5', transform: at })
          : sv('rect', { x: '-3', y: '-5', width: '6', height: '10', rx: '1.5', transform: at + ' rotate(' + c[2] + ')' });
        piece.setAttribute('class', 'mvgw-c' + c[3]);
        g.appendChild(piece);
      }
      svg.appendChild(g);
    }
  }

  /* Big Shoulders 800, the digits 0-9 as outlines in a 50 x 110 cell
     (= .5em x 1.1em, the baseline where CSS would put it). The counter draws
     its rolling digits with these instead of typing them: the browser's
     Largest Contentful Paint measures a strip of text by ALL of its lines —
     also the ones rolled out of sight above the box — and so took the banner
     for the page's main content, moving that measurement to after the app
     had rendered. Outlines are not text, so the cover's sentence stays the
     page's first large paint, as it was before the banner. */
  var DIGITS = [
    'M25 95Q15 95 10 90Q4 85 4 75Q4 68 4 60Q4 53 4 46Q4 39 4 32Q4 22 10 18Q15 13 25 13Q35 13 40 18Q46 22 46 32Q46 38 46 43Q46 49 46 54Q46 60 46 65Q46 70 46 75Q46 85 40 90Q35 95 25 95ZM25 83Q31 83 32 78Q32 70 32 62Q32 54 32 46Q32 38 32 29Q32 24 25 24Q18 24 18 29Q18 36 18 42Q18 48 18 53Q18 59 18 65Q18 71 18 78Q18 83 25 83Z',
    'M20 94V26H14L13 21L22 14H34V94Z',
    'M4 94Q4 92 4 90Q4 89 4 87Q4 86 4 84Q4 83 4 81Q4 80 4 77Q4 72 6 68Q8 63 11 60Q15 56 20 54L26 50Q30 48 31 46Q32 43 32 41Q32 38 32 35Q32 32 32 29Q32 27 30 25Q28 24 25 24Q22 24 20 25Q19 27 18 29Q18 33 18 36Q18 39 18 43H4Q4 41 4 39Q4 37 4 35Q4 33 4 32Q5 21 10 17Q14 13 25 13Q32 13 37 15Q42 16 44 21Q46 25 46 32Q46 33 46 34Q46 35 46 36Q46 37 46 38Q46 40 46 41Q46 46 44 50Q42 54 39 57Q36 60 32 62L24 66Q22 67 21 69Q20 71 19 73Q19 76 19 77V81H45V94Z',
    'M25 95Q14 95 9 90Q3 86 3 75Q3 73 3 72Q3 71 3 70Q3 69 3 67H17V77Q17 80 19 82Q21 83 25 83Q28 83 30 82Q32 80 32 77Q32 74 32 71Q32 68 32 65Q32 62 30 60Q29 58 24 58L14 58L14 47L29 26H4V14H46L46 25L30 46Q38 47 42 51Q46 56 46 66Q46 67 46 68Q46 69 46 70Q46 72 46 73Q46 74 46 75Q46 86 41 90Q36 95 25 95Z',
    'M26 94V73H2V61L21 14H40V61H48V73H40V94ZM15 61H26L28 42L30 26H27L22 42Z',
    'M26 95Q14 95 9 90Q4 86 4 75Q4 72 4 70Q4 69 4 67H18Q18 68 18 70Q18 72 18 74Q18 76 18 77Q18 80 20 82Q22 83 25 83Q29 83 31 82Q32 80 33 77Q33 72 33 68Q33 63 33 60Q32 57 31 55Q29 54 26 54Q24 54 22 55Q20 55 19 57Q18 58 18 59H5V14H46V26H19V48H21Q23 46 26 44Q29 43 33 43Q40 43 43 47Q46 51 47 59Q47 62 47 65Q47 68 47 70Q47 73 47 75Q46 82 44 86Q42 91 37 93Q33 95 26 95Z',
    'M25 95Q14 95 9 90Q4 86 4 75Q4 67 4 60Q4 53 4 47Q4 42 4 38Q4 34 4 32Q5 22 10 17Q15 13 25 13Q35 13 40 18Q46 22 46 31Q46 32 46 33Q46 34 46 35Q46 37 46 38H32Q32 37 32 35Q32 34 32 33Q32 31 32 29Q32 27 30 25Q29 24 25 24Q22 24 20 25Q19 27 18 29Q18 33 18 38Q18 43 18 49H21Q22 47 25 45Q28 43 32 43Q40 43 43 47Q46 51 47 60Q47 63 47 66Q47 68 47 70Q47 72 46 75Q46 86 41 90Q36 95 25 95ZM25 83Q29 83 30 82Q32 80 32 78Q32 75 32 73Q32 71 32 69Q33 67 33 65Q33 63 32 60Q32 58 31 56Q29 55 26 55Q22 55 20 56Q18 58 18 60Q18 64 18 69Q18 73 18 78Q18 80 20 82Q22 83 25 83Z',
    'M9 94 32 26H3V14H46V26L24 94Z',
    'M25 95Q14 95 9 90Q4 85 4 75Q4 74 4 73Q4 72 4 70Q4 69 4 67Q5 62 7 59Q9 56 13 54V52Q10 51 8 48Q6 46 5 43Q5 41 5 39Q4 37 4 35Q4 33 4 32Q5 22 10 17Q14 13 25 13Q36 13 40 17Q45 22 46 32Q46 33 46 35Q46 37 45 39Q45 41 45 42Q44 46 42 48Q40 51 37 52V54Q41 56 43 59Q45 62 46 67Q46 70 46 71Q46 73 46 75Q46 86 41 90Q36 95 25 95ZM25 83Q29 83 30 82Q32 80 32 77Q32 75 32 73Q32 71 32 70Q32 68 32 66Q32 63 30 61Q29 60 25 60Q21 60 20 61Q18 63 18 66Q18 69 18 71Q18 74 18 77Q18 80 20 82Q21 83 25 83ZM25 46Q28 46 30 45Q32 43 32 40Q32 38 32 35Q32 33 32 30Q32 27 30 25Q29 24 25 24Q22 24 20 25Q18 27 18 30Q18 31 18 33Q18 34 18 35Q18 36 18 38Q18 39 18 40Q18 43 20 45Q22 46 25 46Z',
    'M25 95Q14 95 10 90Q5 86 5 75Q5 75 5 73Q5 72 5 71Q5 70 5 69H19Q19 71 19 73Q19 75 19 78Q19 80 20 82Q22 83 25 83Q28 83 30 82Q31 81 32 78Q32 74 32 69Q32 64 32 58H30Q29 61 26 62Q23 64 19 64Q15 64 11 62Q8 60 6 56Q3 53 3 46Q3 44 3 41Q3 39 3 37Q3 35 3 34Q3 33 3 32Q4 22 9 17Q14 13 25 13Q36 13 41 17Q45 22 46 32Q46 41 46 48Q46 55 46 62Q46 68 46 75Q45 86 41 90Q36 95 25 95ZM25 52Q28 52 30 51Q32 50 32 48Q32 43 32 38Q32 34 31 29Q31 27 30 25Q28 24 25 24Q21 24 19 25Q18 27 18 29Q18 30 18 32Q18 34 18 37Q18 40 17 43Q17 46 18 47Q18 50 20 51Q22 52 25 52Z'
  ];

  /* Big Shoulders 800 "+", in the same units (its own 54.1-wide cell). */
  var PLUS = 'M21.8 79.9V63.1H5.1V52.6H21.8V35.9H32.4V52.6H49.1V63.1H32.4V79.9Z';

  /** One digit outline moved down by `dy` (the outlines use only absolute
      M L Q H V Z commands: every second number of M L Q is a y, V is a y). */
  function shiftDigit(d, dy) {
    return d.replace(/([MLQHVZ])([^MLQHVZ]*)/g, function (all, cmd, args) {
      if (cmd === 'Z' || cmd === 'H' || !dy) return all;
      var nums = args.match(/-?\d*\.?\d+/g) || [];
      for (var i = 0; i < nums.length; i++) {
        if (cmd === 'V' || i % 2 === 1) nums[i] = String(+nums[i] + dy);
      }
      return cmd + nums.join(' ');
    });
  }

  /** "150" -> a reel per digit that rolls into place, then "+". A reel is ONE
      path: the digits it rolls through, stacked one 110-unit cell apart. (Not
      one <use> per step: that was 49 extra elements, each with its own
      hidden copy, restyled and laid out again with every change of the page
      while it loads.) */
  function counter(num) {
    var c = el('span', 'mvgw-counter');
    c.setAttribute('aria-hidden', 'true');
    var digits = String(num).replace(/\D/g, '').split('');
    for (var i = 0; i < digits.length; i++) {
      var d = +digits[i];
      var steps = 10 + d + (i === digits.length - 1 ? 10 : 0);
      var dg = el('span', 'mvgw-digit');
      var reel = sv('svg', { 'class': 'mvgw-reel', viewBox: '0 0 50 ' + ((steps + 1) * 110), focusable: 'false', 'aria-hidden': 'true' });
      var strip = [];
      for (var k = 0; k <= steps; k++) strip.push(shiftDigit(DIGITS[k % 10], k * 110));
      reel.appendChild(sv('path', { d: strip.join('') }));
      reel.style.setProperty('--steps', String(steps));
      dg.appendChild(reel);
      c.appendChild(dg);
    }
    /* the "+" is an outline too: nothing in the headline waits for, or
       changes size with, the display font */
    var plus = sv('svg', { 'class': 'mvgw-plus', viewBox: '0 0 54.1 110', focusable: 'false', 'aria-hidden': 'true' });
    plus.appendChild(sv('path', { d: PLUS }));
    c.appendChild(plus);
    return c;
  }

  /** The main line. Its first "150+" becomes the rolling counter; the word
      before and the word after stay on the counter's line. */
  function headline(p, text) {
    p.textContent = '';
    text = String(text || '');
    var m = /(\d{1,6})\s?\+/.exec(text);
    if (!m) { fill(p, text); return; }
    var before = text.slice(0, m.index), after = text.slice(m.index + m[0].length);
    var bm = /(\S+)\s*$/.exec(before), am = /^\s*(\S+)/.exec(after);
    var bHead = bm ? before.slice(0, bm.index) : before;
    var aTail = am ? after.slice(am[0].length) : after;
    if (bHead) { var s1 = el('span'); fill(s1, bHead); p.appendChild(s1); }
    var grp = el('span', 'mvgw-nowrap');
    if (bm) grp.appendChild(document.createTextNode(bm[1] + ' '));
    grp.appendChild(counter(m[1]));
    grp.appendChild(el('span', 'mvgw-sr', m[1] + '+'));
    if (am) grp.appendChild(document.createTextNode(' ' + am[1]));
    p.appendChild(grp);
    if (aTail) { var s2 = el('span'); fill(s2, aTail); p.appendChild(s2); }
  }

  function buildBanner() {
    var root = el('div', 'mvgw-banner');
    root.setAttribute('role', 'region');
    root.setAttribute('data-no-i18n', '1');
    root.setAttribute('translate', 'no');
    root.setAttribute('data-mvgw', 'banner');
    var ticket = el('div', 'mvgw-ticket');
    var main = el('div', 'mvgw-main');
    var slot = el('div', 'mvgw-stamp-slot');
    slot.setAttribute('aria-hidden', 'true');
    slot.appendChild(sv('svg', { 'class': 'mvgw-confetti', viewBox: '-120 -70 240 140', focusable: 'false', 'aria-hidden': 'true' }));
    var stampIn = el('span', 'mvgw-stamp-in');
    stampIn.appendChild(stamp('mvgw-stamp'));
    slot.appendChild(stampIn);
    main.appendChild(slot);
    var words = el('div', 'mvgw-words');
    words.appendChild(el('p', 'mvgw-headline'));
    words.appendChild(el('p', 'mvgw-sub'));
    main.appendChild(words);
    ticket.appendChild(main);
    var stub = el('div', 'mvgw-stub');
    var st = el('p', 'mvgw-stub-text');
    st.appendChild(el('span', 'mvgw-stub-label'));
    st.appendChild(document.createTextNode(' '));
    st.appendChild(el('span', 'mvgw-stub-date'));
    stub.appendChild(st);
    ticket.appendChild(stub);
    var shine = el('span', 'mvgw-shine');
    shine.setAttribute('aria-hidden', 'true');
    ticket.appendChild(shine);
    root.appendChild(ticket);
    return root;
  }

  function paintBanner(root, t, l) {
    root.setAttribute('lang', l);
    root.setAttribute('dir', t.dir);
    root.setAttribute('aria-label', t.stampTop + ' \u2014 ' + t.main);
    paintConfetti(root.querySelector('.mvgw-confetti'), t.dir);
    paintStamp(root.querySelector('.mvgw-stamp'), t);
    headline(root.querySelector('.mvgw-headline'), t.main);
    fill(root.querySelector('.mvgw-sub'), t.sub);
    root.querySelector('.mvgw-stub-label').textContent = t.until;
    root.querySelector('.mvgw-stub-date').textContent = t.date;
  }

  var bannerEl = null, bannerLang = '';

  function bannerPlaced() {
    var p = bannerEl && bannerEl.parentNode;
    return !!(p && bannerEl.isConnected !== false && p.classList && p.classList.contains('mv-rd-hero-in') && p.firstChild === bannerEl);
  }

  /** Above the three columns, inside the same container, so it has their
      width at every size. Re-placed if the app ever re-creates that part. */
  function mountBanner() {
    if (!CFG || !CFG.on || !CFG.banner) return;
    if (bannerPlaced()) return;
    var host = document.querySelector('.mv-rd-hero-in');
    if (!host) return;
    if (!bannerEl) bannerEl = buildBanner();
    var l = siteLang();
    if (l !== bannerLang) { bannerLang = l; paintBanner(bannerEl, words(CFG.t, l), l); }
    host.insertBefore(bannerEl, host.firstChild);
    stats.banner++;
    fitLater(bannerEl);
    watchInView(bannerEl);
  }

  /* The stamp's beat, the confetti and the gleam repeat forever; while the
     banner is scrolled out of sight they wait (and the browser has nothing
     to redraw for them), and go on where they were when it is back. */
  var viewWatched = false;
  function watchInView(root) {
    if (viewWatched || !window.IntersectionObserver) return;
    viewWatched = true;
    try {
      new IntersectionObserver(function (list) {
        var e = list[list.length - 1];
        if (e) root.classList.toggle('mvgw-still', !e.isIntersecting);
      }).observe(root);
    } catch (e) { }
  }

  /* Measuring the stamp words reads the stamp's computed style. While the
     app and its add-ons are still building the page that would force the
     browser to restyle it in the middle of their work, so it waits until
     the browser is idle (and runs again when a font arrives). The built-in
     words fit their rings; only a long custom word is made smaller. */
  function fitLater(root) {
    var run = function () { try { fitStamp(root); } catch (e) { } };
    if (window.requestIdleCallback) requestIdleCallback(run, { timeout: 2500 });
    else if (window.requestAnimationFrame) requestAnimationFrame(function () { setTimeout(run, 0); });
    else setTimeout(run, 50);
  }

  function relang() {
    var l = siteLang();
    if (bannerEl && l !== bannerLang) {
      bannerLang = l;
      paintBanner(bannerEl, words(CFG.t, l), l);
      fitLater(bannerEl);
      stats.relang++;
    }
    if (pop && pop.isOpen && pop.auto && l !== pop.lang) {
      pop.lang = l;
      pop.t = words(pop.texts, l);
      applyPopupText();
    }
  }

  /* =========================================================== the popup === */

  var BURST = [
    [147, -8, 160, 'var(--mvgw-blue)'], [176, 52, -183, 'var(--mvgw-mint)'], [131, 50, 206, 'var(--mvgw-stamp)'],
    [96, 111, -229, 'var(--mvgw-ink)'], [62, 93, 252, '#fff'], [-25, 129, -275, 'var(--mvgw-blue)'],
    [-37, 101, 298, 'var(--mvgw-mint)'], [-142, 98, -321, 'var(--mvgw-stamp)'], [-126, 70, 344, 'var(--mvgw-ink)'],
    [-210, 26, -367, '#fff'], [-172, 10, 390, 'var(--mvgw-blue)'], [-198, -59, -413, 'var(--mvgw-mint)'],
    [-152, -59, 436, 'var(--mvgw-stamp)'], [-108, -125, -459, 'var(--mvgw-ink)'], [-71, -108, 482, '#fff'],
    [28, -145, -505, 'var(--mvgw-blue)'], [42, -117, 528, 'var(--mvgw-mint)'], [159, -109, -551, 'var(--mvgw-stamp)'],
    [145, -81, 574, 'var(--mvgw-ink)'], [148, -18, -597, '#fff']
  ];
  var SPIN = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  var COLORS = ['#2F5BE0', '#10A37F', '#C62A1C', '#FFD23F', '#FFFFFF', '#FF8A3D'];
  var I_COPY = '<svg class="mvgw-i-copy" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="9" width="11" height="11" rx="2.5"/><path d="M15 9V6.5A2.5 2.5 0 0 0 12.5 4h-6A2.5 2.5 0 0 0 4 6.5v6A2.5 2.5 0 0 0 6.5 15H9"/></svg>';
  var I_CHECK = '<svg class="mvgw-i-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var I_DOWN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 4v11"/><path d="M7 10.5l5 5 5-5"/><path d="M5 20h14"/></svg>';
  var I_CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  var pop = null;

  function buildPopup() {
    var hasDialog = typeof document.createElement('dialog').showModal === 'function';
    var dlg = el(hasDialog ? 'dialog' : 'div', 'mvgw-pop' + (hasDialog ? '' : ' mvgw-nodialog'));
    var n = ++uid;
    dlg.setAttribute('data-no-i18n', '1');
    dlg.setAttribute('translate', 'no');
    dlg.setAttribute('aria-labelledby', 'mvgw-title-' + n);
    dlg.setAttribute('aria-describedby', 'mvgw-body-' + n);
    if (!hasDialog) { dlg.setAttribute('role', 'dialog'); dlg.setAttribute('aria-modal', 'true'); }

    var rain = el('div', 'mvgw-rain');
    rain.setAttribute('aria-hidden', 'true');
    dlg.appendChild(rain);

    var card = el('div', 'mvgw-card');
    var x = el('button', 'mvgw-close');
    x.type = 'button';
    x.innerHTML = I_CLOSE;
    card.appendChild(x);

    var top = el('div', 'mvgw-top');
    var slot = el('div', 'mvgw-pstamp-slot');
    slot.setAttribute('aria-hidden', 'true');
    var burst = el('span', 'mvgw-pburst');
    for (var i = 0; i < BURST.length; i++) {
      var b = el('span');
      b.style.cssText = '--dx:' + BURST[i][0] + ';--dy:' + BURST[i][1] + ';--r:' + BURST[i][2] + 'deg;--c:' + BURST[i][3];
      burst.appendChild(b);
    }
    slot.appendChild(burst);
    var st = stamp('mvgw-pstamp');
    slot.appendChild(st);
    top.appendChild(slot);
    var title = el('h2', 'mvgw-title');
    title.id = 'mvgw-title-' + n;
    top.appendChild(title);
    var body = el('p', 'mvgw-body');
    body.id = 'mvgw-body-' + n;
    top.appendChild(body);
    card.appendChild(top);

    var stub = el('div', 'mvgw-pstub');
    var label = el('p', 'mvgw-label');
    stub.appendChild(label);
    var serialBox = el('div', 'mvgw-serial');
    var keyText = el('span', 'mvgw-sr mvgw-key-text');
    var tiles = el('span', 'mvgw-tiles');
    tiles.setAttribute('aria-hidden', 'true');
    serialBox.appendChild(keyText);
    serialBox.appendChild(tiles);
    stub.appendChild(serialBox);

    var actions = el('div', 'mvgw-actions');
    var copyBtn = el('button', 'mvgw-copy');
    copyBtn.type = 'button';
    copyBtn.setAttribute('autofocus', '');
    copyBtn.innerHTML = I_COPY + I_CHECK;
    var copyLabel = el('span', 'mvgw-copy-label');
    copyBtn.appendChild(copyLabel);
    actions.appendChild(copyBtn);
    var dl = el('a', 'mvgw-dl');
    dl.target = '_blank';
    dl.rel = 'noopener noreferrer';
    dl.innerHTML = I_DOWN;
    var dlLabel = el('span', 'mvgw-dl-label');
    dl.appendChild(dlLabel);
    actions.appendChild(dl);
    stub.appendChild(actions);

    var help = el('p', 'mvgw-help');
    var fine = el('p', 'mvgw-fine');
    stub.appendChild(help);
    stub.appendChild(fine);
    card.appendChild(stub);
    dlg.appendChild(card);
    var live = el('p', 'mvgw-sr mvgw-live');
    live.setAttribute('aria-live', 'polite');
    dlg.appendChild(live);

    var p = {
      dlg: dlg, hasDialog: hasDialog, rain: rain, stamp: st, title: title, body: body, label: label,
      keyText: keyText, tiles: tiles, copyBtn: copyBtn, copyLabel: copyLabel, dl: dl, dlLabel: dlLabel,
      help: help, fine: fine, live: live, close: x,
      serial: '', t: words(null, 'en'), lang: 'en', url: '', done: false, safety: 0, copiedTimer: 0,
      isOpen: false, auto: false, preview: false, onCopied: null
    };

    x.addEventListener('click', closePopup);
    if (hasDialog) {
      dlg.addEventListener('cancel', function (e) { e.preventDefault(); closePopup(); });
    }
    dlg.addEventListener('click', function (e) { if (e.target === dlg) closePopup(); });
    copyBtn.addEventListener('click', onCopyClick);
    /* A key selected and copied by hand (Ctrl+C / long-press) counts too. */
    serialBox.addEventListener('copy', function () {
      var sel = '';
      try { sel = String(window.getSelection ? window.getSelection() : '').replace(/\s+/g, ''); } catch (e) { }
      var want = p.serial.replace(/-/g, '');
      if (want && sel.replace(/-/g, '').indexOf(want) !== -1) copiedOk();
    });
    return p;
  }

  function applyPopupText() {
    var t = pop.t;
    pop.dlg.setAttribute('lang', pop.lang);
    pop.dlg.setAttribute('dir', t.dir);
    paintStamp(pop.stamp, t);
    fill(pop.title, t.title);
    fill(pop.body, t.body);
    pop.label.textContent = t.label;
    fill(pop.help, t.help);
    fill(pop.fine, t.fine);
    pop.close.setAttribute('aria-label', t.close);
    pop.copyLabel.textContent = pop.copyBtn.classList.contains('is-copied') ? t.copied : t.copy;
    pop.dlLabel.textContent = t.download;
    if (pop.url) { pop.dl.href = pop.url; pop.dl.style.display = ''; }
    else { pop.dl.removeAttribute('href'); pop.dl.style.display = 'none'; }
    if (pop.isOpen) fitStamp(pop.dlg);
  }

  function buildKey() {
    var serial = pop.serial, frag = document.createDocumentFragment(), n = 0, d = 0;
    for (var c = 0; c < serial.length; c++) {
      var ch = serial.charAt(c);
      if (ch === '-') {
        frag.appendChild(el('span', 'mvgw-dash', '-'));
        d++;
        continue;
      }
      var tile = el('span', 'mvgw-tile'), reel = el('span', 'mvgw-preel');
      var spins = reduce ? 0 : 9 + Math.floor(Math.random() * 5), txt = '';
      for (var k = 0; k < spins; k++) txt += SPIN.charAt(Math.floor(Math.random() * SPIN.length)) + '\n';
      reel.textContent = txt + ch;
      reel.setAttribute('data-final', ch);
      reel.style.setProperty('--steps', String(spins));
      reel.style.setProperty('--i', String(n));
      tile.appendChild(reel);
      frag.appendChild(tile);
      n++;
    }
    pop.tiles.textContent = '';
    pop.tiles.appendChild(frag);
    pop.tiles.style.setProperty('--n', String(Math.max(n, 1)));
    pop.tiles.style.setProperty('--d', String(d));
    pop.keyText.textContent = serial;
  }

  function makeRain() {
    pop.rain.textContent = '';
    if (reduce) return;
    var frag = document.createDocumentFragment();
    for (var i = 0; i < 44; i++) {
      var p = el('span', i % 3 === 0 ? 'is-dot' : '');
      p.style.setProperty('--x', (Math.random() * 100).toFixed(2) + '%');
      p.style.setProperty('--d', (0.45 + Math.random() * 0.8).toFixed(2) + 's');
      p.style.setProperty('--t', (2.4 + Math.random() * 1.5).toFixed(2) + 's');
      p.style.setProperty('--r', (Math.random() < 0.5 ? -1 : 1) * Math.round(360 + Math.random() * 720) + 'deg');
      p.style.setProperty('--s', String(Math.round(14 + Math.random() * 46)));
      p.style.setProperty('--c', COLORS[i % COLORS.length]);
      frag.appendChild(p);
    }
    pop.rain.appendChild(frag);
  }

  /** Every character has locked: plain text again, so it can be selected. */
  function finish() {
    if (!pop || pop.done) return;
    pop.done = true;
    clearTimeout(pop.safety);
    var reels = pop.tiles.querySelectorAll('.mvgw-preel');
    for (var i = 0; i < reels.length; i++) {
      reels[i].textContent = reels[i].getAttribute('data-final');
      reels[i].style.setProperty('--steps', '0');
    }
    pop.dlg.classList.remove('is-revealing');
    pop.dlg.classList.add('is-revealed');
  }

  function resetCopy() {
    clearTimeout(pop.copiedTimer);
    pop.copyBtn.classList.remove('is-copied');
    pop.copyLabel.textContent = pop.t.copy;
  }

  /**
   * opts: { serial, texts (per language, as __mvGwCfg.t), lang (optional —
   * default: the site's, and it follows the switcher), url, preview (the
   * dashboard: nothing is reported), onCopied }
   */
  function openPopup(opts) {
    opts = opts || {};
    var serial = String(opts.serial || '').trim();
    if (!serial) return null;
    if (!pop) pop = buildPopup();
    if (!pop.dlg.parentNode) document.body.appendChild(pop.dlg);
    pop.serial = serial;
    pop.auto = !opts.lang;
    pop.lang = opts.lang || siteLang();
    pop.texts = opts.texts || (CFG && CFG.t) || null;
    pop.t = opts.words || words(pop.texts, pop.lang);
    pop.url = String(opts.url || '').trim();
    if (!/^https?:\/\//i.test(pop.url)) pop.url = '';         // only a web address, never script
    pop.preview = !!opts.preview;
    pop.onCopied = typeof opts.onCopied === 'function' ? opts.onCopied : null;
    pop.done = false;
    applyPopupText();
    buildKey();
    makeRain();
    resetCopy();
    pop.live.textContent = '';
    var d = pop.dlg;
    d.classList.remove('is-open', 'is-revealing', 'is-revealed', 'is-closing');
    if (pop.hasDialog) {
      if (!d.open) { try { d.showModal(); } catch (e) { d.setAttribute('open', ''); } }
    } else {
      d.setAttribute('open', '');
      document.addEventListener('keydown', onEsc, true);
    }
    pop.isOpen = true;
    document.documentElement.classList.add('mvgw-lock');
    void d.offsetWidth;                          // restarts the animations on a second open
    d.classList.add('is-open');
    fitStamp(d);
    if (!pop.hasDialog) { try { pop.copyBtn.focus(); } catch (e) { } }
    stats.popup++;
    if (reduce) { finish(); return pop; }
    d.classList.add('is-revealing');
    var reels = pop.tiles.querySelectorAll('.mvgw-preel'), last = reels[reels.length - 1];
    if (last) last.addEventListener('animationend', finish, { once: true });
    pop.safety = setTimeout(finish, 5000);
    return pop;
  }

  function onEsc(e) { if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); closePopup(); } }

  function closePopup() {
    if (!pop || !pop.isOpen || pop.dlg.classList.contains('is-closing')) return;
    var d = pop.dlg;
    d.classList.add('is-closing');
    document.removeEventListener('keydown', onEsc, true);
    setTimeout(function () {
      if (pop.hasDialog) { try { d.close(); } catch (e) { d.removeAttribute('open'); } }
      else d.removeAttribute('open');
      d.classList.remove('is-closing', 'is-open', 'is-revealing', 'is-revealed');
      document.documentElement.classList.remove('mvgw-lock');
      pop.isOpen = false;
    }, reduce ? 0 : 200);
  }

  function legacyCopy(text) {
    var area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.cssText = 'position:fixed;top:0;left:0;opacity:0;';
    pop.dlg.appendChild(area);
    area.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { }
    pop.dlg.removeChild(area);
    return ok ? Promise.resolve() : Promise.reject(new Error('copy'));
  }

  function writeClipboard(text) {
    if (navigator.clipboard && window.isSecureContext && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).catch(function () { return legacyCopy(text); });
    }
    return legacyCopy(text);
  }

  function copiedOk() {
    if (!pop) return;
    var t = pop.t;
    pop.copyBtn.classList.add('is-copied');
    pop.copyLabel.textContent = t.copied;
    pop.live.textContent = t.copied;
    clearTimeout(pop.copiedTimer);
    pop.copiedTimer = setTimeout(resetCopy, 2600);
    if (pop.preview) return;
    if (!pop.reportedFor || pop.reportedFor !== pop.serial) {
      pop.reportedFor = pop.serial;
      stats.copied++;
      markDone(pop.serial);
      reportCopied(pop.serial);
      if (pop.onCopied) { try { pop.onCopied(pop.serial); } catch (e) { } }
    }
  }

  function onCopyClick() {
    finish();
    writeClipboard(pop.serial).then(copiedOk, function () {
      /* The browser refused: select the key so it can be copied by hand
         (the copy event above still records it). */
      try {
        var range = document.createRange();
        range.selectNodeContents(pop.tiles);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      } catch (e) { }
    });
  }

  /* =================================================== copied, remembered === */

  function hash(s) {
    var h = 5381;
    for (var i = 0; i < s.length; i++) h = ((h << 5) + h + s.charCodeAt(i)) | 0;
    return (h >>> 0).toString(36);
  }
  function doneList() {
    try { var a = JSON.parse(store(DONE_KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; }
  }
  function isDone(serial) { return doneList().indexOf(hash(serial)) !== -1; }
  function markDone(serial) {
    var a = doneList(), h = hash(serial);
    if (a.indexOf(h) === -1) a.push(h);
    store(DONE_KEY, JSON.stringify(a.slice(-20)));
  }

  function deviceId() { return store('mv_device_id') || ''; }

  /** Tells the server; the dashboard's Free Serial box turns green. */
  function reportCopied(serial) {
    stats.reported++;
    try {
      fetch('/api/giveaway.php', {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ action: 'copied', serial: serial, deviceId: deviceId() })
      }).catch(function () { });
    } catch (e) { }
  }

  /** Is there a serial waiting for THIS visitor? Asked once per page load. */
  function checkMe() {
    if (!CFG || !CFG.on || !CFG.me) return;
    if (/^\/(admin|dashboard)(\/|$)/i.test(location.pathname)) return;
    loadDisplayFont();
    fetch('/api/giveaway.php?me=1', { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j.show || !j.serial) return;
        if (isDone(j.serial)) { reportCopied(j.serial); return; }   // copied before; the report was lost
        openPopup({ serial: j.serial, texts: CFG.t, url: CFG.url });
      })
      .catch(function () { });
  }

  function whenAppReady(fn) {
    var tries = 0;
    (function wait() {
      if (document.querySelector('header') || ++tries > 40) { fn(); return; }
      setTimeout(wait, 250);
    })();
  }

  /* ================================================================ boot === */

  /* The display face (stamp, date, key tiles). The banner does not ask for
     it early: the browser fetches it when the banner is first drawn, after
     the app's own files, and nothing in the banner moves when it arrives
     (see "MV Big Shoulders Fallback" in the CSS). For the popup it is asked
     for together with the serial. */
  function loadDisplayFont() {
    try {
      if (document.fonts && document.fonts.load) document.fonts.load('800 1em "MV Big Shoulders"').then(null, function () { });
    } catch (e) { }
  }

  function boot() {
    if (CFG && CFG.on && CFG.banner) {
      /* Built now, while the app is still starting, so the app's first
         commit (where it is inserted) only has to place it. */
      try {
        bannerEl = buildBanner();
        bannerLang = siteLang();
        paintBanner(bannerEl, words(CFG.t, bannerLang), bannerLang);
      } catch (e) { bannerEl = null; bannerLang = ''; }
      mountBanner();
      var root = document.getElementById('root') || document.body;
      if (window.MutationObserver && root) {
        new MutationObserver(function () { if (!bannerPlaced()) mountBanner(); })
          .observe(root, { childList: true, subtree: true });
      }
      /* the stamp's words are measured again whenever a font arrives (the
         display face comes after the banner is drawn) */
      try {
        if (document.fonts && document.fonts.addEventListener) {
          document.fonts.addEventListener('loadingdone', function () { if (bannerEl && bannerEl.isConnected !== false) fitLater(bannerEl); });
        }
      } catch (e) { }
    }
    if (CFG && CFG.on && window.MutationObserver) {
      new MutationObserver(relang).observe(document.documentElement, { attributes: true, attributeFilter: ['lang', 'dir'] });
    }
    if (CFG && CFG.on && CFG.me) {
      var go = function () { whenAppReady(function () { setTimeout(checkMe, 800); }); };
      if (document.readyState === 'complete') go();
      else window.addEventListener('load', go, { once: true });
    }
  }

  window.MavelyGiveaway = {
    version: 1,
    lang: siteLang,
    words: words,
    /** Draws a banner into `host` (the dashboard preview). */
    renderBanner: function (host, texts, lang) {
      var b = buildBanner(), l = lang || siteLang();
      paintBanner(b, words(texts, l), l);
      host.textContent = '';
      host.appendChild(b);
      fitStamp(b);
      return b;
    },
    openPopup: openPopup,
    closePopup: closePopup
  };
  window.__mvGiveaway = function () {
    return {
      config: CFG ? { on: CFG.on, banner: CFG.banner, me: CFG.me, url: CFG.url } : null,
      lang: siteLang(), bannerPlaced: bannerPlaced(), popupOpen: !!(pop && pop.isOpen), stats: stats
    };
  };

  boot();
})();
